import { storePagination } from '@/mixins/store'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  filters: {
    storeId: null,
    checkingAccountId: null,
    period: {
      startDate: null,
      endDate: null,
    },
  },
  ddaList: [],
  reportData: null,
})

export default {
  namespaced: true,
  state: getInitialState(),

  mutations: {
    ...storePagination.mutations,

    SET_DDAS(state, ddaList) {
      state.ddaList = ddaList
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    SET_REPORT_DATA(state, reportData) {
      state.reportData = reportData
    },
    CLEAN_STATE(state) {
      const { filters, paging, ddaList } = getInitialState()
      state.filters = filters
      state.ddaList = ddaList
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchDda({ commit, state }) {
      const { period } = state.filters
      const { startDate, endDate } = period

      const params = {
        ...state.filters,
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
        initialDate: startDate,
        finalDate: endDate,
      }

      const { data } = await axios.get('/api/financial/internet-banking/payments/bank-slip/dda', {
        params,
      })

      commit('SET_DDAS', data || [])

      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    async fetchDdaFind({ commit, state }) {
      const { period } = state.filters
      const { startDate, endDate } = period

      const params = {
        ...state.filters,
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
        initialDate: startDate,
        finalDate: endDate,
      }

      const { data } = await axios.get('/api/financial/internet-banking/payments/bank-slip/dda-find', {
        params,
      })

      commit('SET_DDAS', data || [])

      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    setFilters({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },

    async generateReport({ state, commit }) {
      const { period } = state.filters
      const { startDate, endDate } = period

      const params = {
        ...state.filters,
        initialDate: startDate,
        finalDate: endDate,
      }

      const { data } = await axios.get(
        '/api/financial/internet-banking/payments/bank-slip/dda/download',
        {
          params,
          responseType: 'blob',
        }
      )

      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      commit('SET_REPORT_DATA', url)
    },
  },
}
